import script from "./GestaoGrupos.vue?vue&type=script&setup=true&lang=js"
export * from "./GestaoGrupos.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__